export const LAYER_COLORS = {
  input: "red",
  mainPolygon: "red",
};
export const getPredictionColors = (predictionHours, timeStep, totalContours) => {
  const dtMinutesMap = { "1h": 60, "30min": 30, "45min": 45, "15min": 15 };
  const dtMinutes = dtMinutesMap[timeStep] || 60;
  const contoursPerHour = 60 / dtMinutes; // 4 for 15min, 2 for 30min, 1 for 1h

  const hourBuckets = predictionHours;

  // Generate one color per hour bucket: yellow → orange → red
  const bucketColors = Array.from({ length: hourBuckets }, (_, i) => {
    const t = hourBuckets === 1 ? 1 : i / (hourBuckets - 1);
    return interpolateYellowToRed(t);
  });

  // Each contour gets the color of its hour bucket
  return Array.from({ length: totalContours }, (_, idx) => {
    const hourIndex = Math.floor(idx / contoursPerHour);
    const clampedIndex = Math.min(hourIndex, hourBuckets - 1);
    return bucketColors[clampedIndex];
  });
};

export function interpolateYellowToRed(t) {
  let r, g, b;
  if (t < 0.5) {
    const s = t / 0.5;
    r = 255;
    g = Math.round(255 - s * (255 - 102));
    b = 0;
  } else {
    const s = (t - 0.5) / 0.5;
    r = Math.round(255 - s * (255 - 204));
    g = Math.round(102 - s * 102);
    b = 0;
  }
  return `rgb(${r},${g},${b})`;
}